module.exports = __webpack_public_path__ + "static/img/people_09.bcd85af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/track/textures/people/people_09.png
// module id = 509
// module chunks = 1